/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styles from "./DatePicker.module.css";
import { addDays, addMonths, differenceInMonths, subMonths, format, isSameDay,  lastDayOfMonth, startOfMonth, subDays } from "date-fns";
/*istanbul ignore next */
export default function DatePicker({
  endDate,
  selectDate,
  getSelectedDay,
  color,
  labelFormat
}) {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const firstSection = {
    marginLeft: '40px'
  };
  const lastDate  = new Date();
  const startDate = subDays(lastDate,  endDate);
  
 

  const primaryColor = color || 'rgba(255, 99, 2, 0.82)';
  const selectedStyle = {
    color: '#fff',
    borderRadius: '12pt',
    boxShadow: '0 10px 12px -6px #f4f1f1',
    border: '1px solid #e9ecef',
    background: primaryColor

  };
  const buttonColor = {
    background: primaryColor
  };
  const labelColor = {
    color: primaryColor
  };
  
  const getStyles = day => {
    if (isSameDay(day, selectedDate)) {
      return selectedStyle;
    }

    return null;
  };

  const getId = day => {
    if (isSameDay(day, selectedDate)) {
      return 'selected';
    } else {
      return "";
    }
  };

  function renderDays() {
    const dayFormat = "E";
    const dateFormat = "d";
    const months = [];
    let days = [];

    for (let i = 0; i <=  differenceInMonths(lastDate, startDate); i++) {
      let start, end;
      const month = startOfMonth(addMonths(startDate, i));
      start = i === 0 ? Number(format(startDate, dateFormat)) - 1  :  0;
      end = i === differenceInMonths(lastDate, startDate) ? Number(format(lastDate, "d")) : Number(format(lastDayOfMonth(month), "d"));
      for (let j = start; j < end; j++) {
        days.push( /*#__PURE__*/React.createElement("div", {
          id: `${getId(addDays(startDate, j))}`,
          className: styles.dateDayItem,
          style: getStyles(addDays(month, j)),
          key: addDays(month, j),
          onClick: () => onDateClick(addDays(month, j))
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.dayLabel
        }, format(addDays(month, j), dayFormat)), /*#__PURE__*/React.createElement("div", {
          className: styles.dateLabel
        }, format(addDays(month, j), dateFormat))));
      }

      months.push( /*#__PURE__*/React.createElement("div", {
        className: styles.monthContainer,
        key: month
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.monthYearLabel,
        style: {color: '#224691'}
      }, format(month, labelFormat || "MMMM yyyy")), /*#__PURE__*/React.createElement("div", {
        className: styles.daysContainer,
        style: i === 0 ? firstSection : null
      }, days)));
      days = [];
    }

    return /*#__PURE__*/React.createElement("div", {
      id: "container",
      className: styles.dateListScrollable
    }, months);
  }

  const onDateClick = day => {
    setSelectedDate(day);

    if (getSelectedDay) {
      getSelectedDay(day);
    }
  };

  useEffect(() => {
    if (getSelectedDay) {
      if (selectDate) {
        getSelectedDay(selectDate);
      } else {
        getSelectedDay(lastDate);
      }
    }

    const e = document.getElementById('container');
    e.scrollLeft +=1000000000000;


  }, []);
  useEffect(() => {
    if (selectDate) {
      if (!isSameDay(selectedDate, selectDate)) {
        setSelectedDate(selectDate);
        setTimeout(() => {
          let view = document.getElementById('selected');

          if (view) {
            view.scrollIntoView({
              behavior: "smooth",
              inline: "center",
              block: "nearest"
            });
          }
        }, 20);
      }
    }
  }, [selectDate]);

  const nextWeek = () => {
    const e = document.getElementById('container');
    const width = e ? e.getBoundingClientRect().width : null;
    e.scrollLeft += width - 60;
  };

  const prevWeek = () => {
    const e = document.getElementById('container');
    const width = e ? e.getBoundingClientRect().width : null;
    e.scrollLeft -= width - 60;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.buttonWrapper
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.button,
    style: buttonColor,
    onClick: prevWeek
  }, "\u2190")), renderDays(), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonWrapper
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.button,
    style: buttonColor,
    onClick: nextWeek
  }, "\u2192")));
}